import { render } from "./SustainabilityContent.vue?vue&type=template&id=e64a3664&scoped=true"
import script from "./SustainabilityContent.vue?vue&type=script&lang=js"
export * from "./SustainabilityContent.vue?vue&type=script&lang=js"

import "./SustainabilityContent.vue?vue&type=style&index=0&id=e64a3664&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e64a3664"]])

export default __exports__